<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1 class="mb-2">Manage Help Center Categories</h1>
        <v-btn
          data-testid="help-categories-create-btn"
          class="help-categories-create-btn mb-4 ml-0"
          :to="{ name: 'helpCenterCategoryCreate' }"
          color="primary"
        >
          <v-icon>add</v-icon>
          Add New Help Center Category
        </v-btn>

        <v-data-table
          :footer-props="{
            ...footerProps,
            itemsPerPageOptions: [10, 25, 50, 75, 100]
          }"
          :headers="headers"
          :items="categories"
          :loading="loadingState.includes('getting all help center categories')"
          :options.sync="pagination"
          :server-items-length="pagination.totalItems"
          data-testid="help-categories-index-datatable"
          class="help-categories-index-datatable"
        >
          <template v-slot:body="{ items }">
            <transition-group
              name="scroll-y-transition"
              tag="tbody"
              v-if="items.length"
            >
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.slug }}</td>
                <td>{{ formatDate(item.updated_at) }}</td>
                <td>{{ truncateContent(item.description, 150) }}</td>
                <td>
                  <v-btn
                    data-testid="help-categories-edit-btn"
                    class="help-categories-edit-btn ml-0 mr-3"
                    color="primary"
                    small
                    @click="handleGetIndividualCategory(item.id)"
                    :loading="loadingState.includes('getting individual help center category')"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    data-testid="help-categories-delete-btn"
                    class="help-categories-delete-btn ml-0 mt-1"
                    color="error"
                    small
                    @click="openDelete(item)"
                    :loading="loadingState.includes('deleting help center category')"
                  >
                    Delete
                  </v-btn>
                </td>
              </tr>
            </transition-group>
            <tr v-else>
              <td colspan="12" style="text-align: center">
                {{  noDataText }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <delete-modal
      v-model="modal"
      @delete="deleteCategory"
      :itemType="'Help Center Category'"
      :advisory="advisory"
    />
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import Mixins from "../mixins.js";
import { categoriesHeader } from "@/helpers/help-center/categories-entries-data-tables";
import { categoryAdvisoryText } from "@/helpers/help-center/category-advisory-text";
import { footerProps } from "@/helpers/footer-props";
import { formatDate } from "@/helpers/functions/format-date";
import { genericAdvisory } from "@/helpers/warning-advisory-text";
import { truncateContent } from "@/helpers/functions/truncate-content";

export default {
  components: {
    ApplicationLayout,
    DeleteModal
  },

  mixins: [Mixins],

  data() {
    return {
      categoryAdvisoryText: categoryAdvisoryText,
      genericAdvisoryText: genericAdvisory,
      headers: categoriesHeader,
      footerProps: footerProps,
      modal: false,
      selectedCategory: ""
    };
  },

  methods: {
    formatDate: formatDate,
    truncateContent: truncateContent,
    async handleGetIndividualCategory(id) {
      await this.$store.dispatch("helpCenter/getCategory", id);
      this.$router.push({ name: "helpCenterCategoryEdit", params: { categoryId: id } });
    },
    openDelete(item) {
      this.modal = true;
      this.selectedCategory = item;
    },
    async deleteCategory() {
      await this.$store.dispatch("helpCenter/deleteCategory", this.selectedCategory.id);
      this.selectedCategory = "";
      this.modal = false;
    }
  },

  watch: {
    pagination: {
      handler() {
        this.$store.dispatch("helpCenter/getAllCategories");
      },
      deep: true
    }
  },

  computed: {
    advisory() {
      if (this.selectedCategory.entries && this.selectedCategory.entries.length) {
        return this.categoryAdvisoryText;
      }
      return this.genericAdvisoryText;
    },
    categories() {
      return this.$store.getters["helpCenter/categoriesList"];
    },
    loadingState() {
      return this.$store.getters["helpCenter/loadingState"];
    },
    noDataText() {
      return this.loadingState.includes("getting all help center categories")
        ? "Retrieving help center categories..."
        : "No categories found";
    },
    pagination: {
      get() {
        return this.$store.getters["helpCenter/categoriesPagination"];
      },
      set(newValue) {
        this.$store.commit("helpCenter/setCategoriesPagination", newValue);
      }
    }
  }
};
</script>
